/* eslint "import/no-mutable-exports": "off" */
const maritalStatuses = {
  SINGLE: { type: 'SINGLE', title: 'martial_status.single', intl: true },
  MARRIED: { type: 'MARRIED', title: 'martial_status.married', intl: true },
  COHABITATING: { type: 'COHABITATING', title: 'martial_status.cohabitating', intl: true },
  DIVORCED: { type: 'DIVORCED', title: 'martial_status.divorced', intl: true },
  WIDOWED: { type: 'WIDOWED', title: 'martial_status.widowed', intl: true },
  OTHER: { type: 'OTHER', title: 'martial_status.other', intl: true },
  PARTNER: { type: 'PARTNER', title: 'martial_status.partner', intl: true },
};

const defaultTypes = [
  maritalStatuses.SINGLE,
  maritalStatuses.MARRIED,
  maritalStatuses.COHABITATING,
  maritalStatuses.DIVORCED,
  maritalStatuses.WIDOWED,
];

const plTypes = [
  maritalStatuses.SINGLE,
  maritalStatuses.MARRIED,
  maritalStatuses.COHABITATING,
  maritalStatuses.DIVORCED,
  maritalStatuses.WIDOWED,
];

const auTypes = [
  maritalStatuses.SINGLE,
  maritalStatuses.MARRIED,
  maritalStatuses.PARTNER,
  maritalStatuses.DIVORCED,
  maritalStatuses.WIDOWED,
];

let data = [];

switch (COUNTRY) {
  case 'PL':
    data = data.concat(plTypes);
    break;
  case 'AU':
    data = data.concat(auTypes);
    break;
  default:
    data = data.concat(defaultTypes);
}

export default data;
